export const ProjectsInfo = [
  {
    img: "image1",
    detail: "type: web application",
    title: "Doc Talents",
    description:
      "Platform offering a comprehensive solution for managing doctoral candidate registrations, research, and statistics simplifying the process from initial enrollment to graduation.",

    technologies: ["react", "node", "tailwind", "mysql"],
    link: "https://github.com/Imeneallouche/Doc-Talents-Website",
  },

  {
    img: "image1",
    detail: "type: Desktop application",
    title: "Smart Time Planner",
    description:
      "Application for task organization providing users with the ability to plan tasks with automated/manual adjustments. It integrates with your daily schedule, ensuring tasks fit into your free time",
    technologies: ["java", "javafx", "css"],
    link: "https://github.com/Imeneallouche/Smart-Time-Planner",
  },

  {
    img: "image1",
    detail: "type: web application",
    title: "MindScape",
    description:
      "Online mental health therapy platform uniting certified therapists and individuals to enhance mental health by providing a digital space for professional therapeutic interactions.",
    technologies: ["react", "tailwind", "django", "mongodb"],
    link: "https://github.com/Imeneallouche/IWD23",
  },
  {
    img: "image1",
    detail: "type: web application",
    title: "Portfolio",
    description:
      "My portfolio is a showcase of my creative projects, professional journey, and the services I offer. Explore my work, experience, and let's connect to bring your ideas to life.",
    technologies: ["react", "tailwind"],
    link: "https://github.com/Imeneallouche/Portfolio",
  },
  {
    img: "image1",
    detail: "type: web application",
    title: "Aspirion",
    description:
      "Aspirion is your all-in-one communication platform, enabling you to chat, voice call, and video call your friends seamlessly. Stay connected effortlessly.",
    technologies: ["react", "tailwind", "node", "mongodb"],
    link: "https://github.com/Imeneallouche/Aspirion-Frontend",
  },
];
